import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Spinner } from '@/shared/components/Spinner';
import { fetchAuthBlob, ApiError } from '@/lib/api-client';
export function MaterialViewerModal({ endpoint, downloadEndpoint, title, onClose, }) {
    const [objectUrl, setObjectUrl] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    useEffect(() => {
        if (!endpoint) {
            setObjectUrl(null);
            setError(null);
            return;
        }
        let cancelled = false;
        let createdUrl = null;
        setLoading(true);
        setError(null);
        setObjectUrl(null);
        fetchAuthBlob(endpoint)
            .then(({ blob }) => {
            if (cancelled)
                return;
            createdUrl = URL.createObjectURL(blob);
            setObjectUrl(createdUrl);
        })
            .catch((err) => {
            if (cancelled)
                return;
            setError(err instanceof ApiError ? err.message : 'No se pudo cargar el documento.');
        })
            .finally(() => {
            if (!cancelled)
                setLoading(false);
        });
        return () => {
            cancelled = true;
            if (createdUrl)
                URL.revokeObjectURL(createdUrl);
        };
    }, [endpoint]);
    useEffect(() => {
        if (!endpoint)
            return;
        function handleKey(e) {
            if (e.key === 'Escape')
                onClose();
        }
        document.addEventListener('keydown', handleKey);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleKey);
            document.body.style.overflow = '';
        };
    }, [endpoint, onClose]);
    if (!endpoint)
        return null;
    async function handleDownload() {
        if (!downloadEndpoint)
            return; // no download affordance (view-only)
        // Fetch the ORIGINAL file and trigger a save dialog.
        setDownloading(true);
        try {
            const { blob, fileName: name } = await fetchAuthBlob(downloadEndpoint);
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = name ?? title;
            a.click();
            // Give the browser a tick to start the download before revoking.
            setTimeout(() => URL.revokeObjectURL(url), 1_000);
        }
        catch (err) {
            const message = err instanceof ApiError ? err.message : 'No se pudo descargar el archivo.';
            alert(message);
        }
        finally {
            setDownloading(false);
        }
    }
    return createPortal(_jsxs("div", { className: "fixed inset-0 z-50 flex flex-col bg-black/80 backdrop-blur-sm", children: [_jsxs("div", { className: "flex items-center gap-3 border-b px-4 py-2.5", style: { background: 'var(--surface)', borderColor: 'var(--border)' }, children: [_jsx("p", { className: "flex-1 truncate text-sm font-semibold", style: { color: 'var(--fg)' }, children: title }), downloadEndpoint && (_jsxs("button", { type: "button", onClick: handleDownload, disabled: !objectUrl || downloading, className: "flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors disabled:opacity-50", style: { color: 'var(--accent)' }, onMouseEnter: (e) => {
                            if (objectUrl && !downloading)
                                e.currentTarget.style.background = 'var(--hover)';
                        }, onMouseLeave: (e) => (e.currentTarget.style.background = 'transparent'), children: [downloading && _jsx(Spinner, { size: "sm" }), "Descargar"] })), _jsx("button", { type: "button", onClick: onClose, "aria-label": "Cerrar visor", className: "rounded-lg p-1.5 transition-colors", style: { color: 'var(--fg-2)' }, onMouseEnter: (e) => (e.currentTarget.style.background = 'var(--hover)'), onMouseLeave: (e) => (e.currentTarget.style.background = 'transparent'), children: _jsxs("svg", { viewBox: "0 0 20 20", className: "h-5 w-5", fill: "none", stroke: "currentColor", strokeWidth: 2, children: [_jsx("line", { x1: "5", y1: "5", x2: "15", y2: "15" }), _jsx("line", { x1: "15", y1: "5", x2: "5", y2: "15" })] }) })] }), _jsxs("div", { className: "relative flex flex-1 items-center justify-center overflow-hidden", children: [loading && (_jsxs("div", { className: "flex items-center gap-2 text-sm", style: { color: 'var(--fg)' }, children: [_jsx(Spinner, { size: "md" }), _jsx("span", { children: "Cargando documento\u2026" })] })), error && (_jsxs("div", { className: "rounded-xl border p-6 text-center", style: { background: 'var(--surface)', borderColor: 'var(--border)' }, children: [_jsx("p", { className: "text-sm font-semibold", style: { color: '#dc2626' }, children: error }), _jsx("p", { className: "mt-1 text-xs", style: { color: 'var(--fg-2)' }, children: "Cierra el visor e int\u00E9ntalo de nuevo." })] })), !loading && !error && objectUrl && (_jsx("iframe", { src: objectUrl, title: title, className: "h-full w-full border-0", style: { background: '#1f2937' } }))] })] }), document.body);
}
//# sourceMappingURL=MaterialViewerModal.js.map